module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_8017.58e69fa3.png";